export var isMobile = function isMobile() {
  return typeof document !== 'undefined' && 'ontouchstart' in document.documentElement;
};